"use client"

import { Button } from "@/components/ui/button"
import { Download, Play } from "lucide-react"

interface FileItemProps {
  name: string
  size: string
  type: "pdf" | "docx" | "video"
  onDownload?: () => void
  onOpen?: () => void
}

export function ResourceFileItem({ name, size, type, onDownload, onOpen }: FileItemProps) {
  const getFileIcon = () => {
    switch (type) {
      case "pdf":
        return "📄"
      case "docx":
        return "📝"
      case "video":
        return "🎬"
      default:
        return "📎"
    }
  }

  const getFileColor = () => {
    switch (type) {
      case "pdf":
        return "text-red-500"
      case "docx":
        return "text-blue-500"
      case "video":
        return "text-red-600"
      default:
        return "text-gray-500"
    }
  }

  return (
    <div className="flex items-center justify-between p-3 bg-muted rounded-lg hover:bg-muted/80 transition-colors">
      <div className="flex items-center space-x-3">
        <span className={`text-3xl ${getFileColor()}`}>{getFileIcon()}</span>
        <div>
          <p className="font-medium text-sm">{name}</p>
          <p className="text-xs text-muted-foreground">{size}</p>
        </div>
      </div>
      <div className="flex gap-2">
        {type === "video" && onOpen ? (
          <Button size="sm" variant="ghost" onClick={onOpen} className="text-primary hover:bg-primary/10">
            <Play className="w-4 h-4 mr-1" />
            Open
          </Button>
        ) : (
          <Button size="sm" variant="ghost" onClick={onDownload} className="text-primary hover:bg-primary/10">
            <Download className="w-4 h-4" />
          </Button>
        )}
      </div>
    </div>
  )
}
